import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { Spinner } from "reactstrap";

import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import {
  formatAmount,
  HandlePurchaseRequestStatus,
  printData,
} from "../../../utility/CommonFunctions";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import ExportDataHandler from "../../../utility/ExportDataHandler";

import MainHeading from "../../../components/comman/MainHeading";
import CommonTable from "../../../components/comman/CommonTable";
import Logs from "../../Logs/Logs";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import CreateVoucherModal from "../Voucher/CreateVoucherModal";
import AlertModal from "../PaymentTickets/AlertModel";

import BankIcon from "../../../components/Icons/BankIcon";
import ViewIcon from "../../../components/Icons/ViewIcon";
import CheckIcon from "../../../components/Icons/CheckIcon";
import CrossIcon from "../../../components/Icons/CrossIcon";

export default function SalaryTicketDetails() {
  let { id } = useParams();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.root.userDetails);
  const [dataLoading, setDataLoading] = useState(true);
  const [state, setState] = useState({
    salaryTicketData: {},
    siteBudget: [],
    loading: false,
    IncreaseLoading: false,
  });
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    VoucherList: [],
    siteList: [],
    searchQuery: "",
    sortByDate: "",
    year: "",
    siteId: "",
    downloadLoading: false,
    taxableAmount: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [refreshLogs, setRefreshLogs] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modal, setModal] = useState({
    approveRejectModal: false,
    createVoucherModel: false,
  });

  const [alertModal, setAlertModal] = useState(false);
  const toggleAlertModal = () => {
    setAlertModal(!alertModal);
  };
  const toggle = (type) => {
    printData(type);
    setModal((prevModal) => ({
      ...prevModal,
      approveRejectModal:
        type === "approveReject"
          ? !prevModal.approveRejectModal
          : prevModal.approveRejectModal,
      createVoucherModel:
        type === "voucher"
          ? !prevModal.createVoucherModel
          : prevModal.createVoucherModel,
    }));
  };

  useEffect(() => {
    GetSalaryTicketDetail();
  }, []);

  const GetSalaryTicketDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_salary_ticket_detail + `salaryTicketId=${id}`;
    callApi(API, options).then((response) => {
      setDataLoading(false);
      if (response?.status === true) {
        setState((pre) => ({
          ...pre,
          salaryTicketData: response?.data,
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  useEffect(() => {
    GetVoucherList(pageStates?.currentPage);
  }, [pageStates?.currentPage, pageStates?.searchQuery, pageStates?.pageSize]);

  const GetVoucherList = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_voucher +
      MainFilterHandler(pageStates) +
      `&salaryTicketId=${id}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.voucher?.map((item) => ({
          ...item,
          recieverName:
            item?.Transactions?.[0]?.referenceName ||
            item?.Transactions?.[0]?.accountHolderName,
          paymentTicketType: item?.paymentticket?.type,
          transDate: moment(item?.transactionDate).format("DD-MM-YYYY"),
          stNumber: item?.salaryticket?.ticketNumber,
          siteName: item?.salaryticket?.site?.name,
          amount: formatAmount(item?.Transactions?.[0]?.amount),
          createdBy: item?.Transactions?.[0]?.user?.name,
          paymentMethods: item?.Transactions?.[0]?.paymentMethod,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          VoucherList: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const handleReqStatus = (status, reason = "") => {
    setIsLoading(true);

    let postData = {
      status: status,
      ...(status === "Rejected" && { rejectReason: reason }),
    };
    const option = {
      method: "POST",
      data: postData,
    };

    callApi(
      apiUrl.update_salary_ticket_status + `?salaryTicketId=${id}`,
      option
    )
      .then((res) => {
        setIsLoading(false);
        if (res?.status === true) {
          toast.success(res?.message);
          GetSalaryTicketDetail();
          setRefreshLogs(true);
        } else {
          toast.error(res?.message);
        }
        toggle("approveReject");
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const HandleView = (data) => {
    navigate(RoutesLink.voucher_detail + `/${data?.id}`);
  };

  const TableHeading = [
    { value: "voucherNumber", label: "Payment Advisory NO." },
    { value: "stNumber", label: "ST NO." },
    { value: "recieverName", label: "Reciever Name" },
    { value: "transDate", label: "Date" },
    { value: "siteName", label: "Site" },
    { value: "createdBy", label: "Created By" },
    { value: "paymentMethods", label: "Payment Method" },
    { value: "amount", label: "Amount" },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const handleExportBankData = (data) => {
    const startDate = moment(data?.month, ["MM/YYYY", "YYYY-MM-DD", "YYYY-MM"])
      .startOf("month")
      .format("YYYY-MM-DD");
    const endDate = moment(data?.month, ["MM/YYYY", "YYYY-MM-DD", "YYYY-MM"])
      .endOf("month")
      .format("YYYY-MM-DD");

    let exportData = {
      exportDataType: "bankPayoutData",
      siteId: data?.siteId,
      months: [startDate, endDate],
      companyId: data?.companyId,
    };
    ExportDataHandler(exportData, true);
  };

  const canChangeStatus = Boolean(
    !dataLoading && state?.salaryTicketData?.canChangeStatus
  );

  const canCreateVoucher = Boolean(
    state?.salaryTicketData?.canCreateVoucher &&
      userDetails?.designation?.canCreate?.includes("voucher")
  );

  const hasAnyAction = canChangeStatus || canCreateVoucher;

  const totalEmployeesCount =
    state?.salaryTicketData?.salaryticketitems?.length || 0;

  const renderActionButtons = (size = "md") => {
    const isSmall = size === "sm";
    const btnClass = isSmall ? "btn btn-sm" : "btn";

    return (
      <div className="d-flex align-items-center flex-wrap gap-2">
        {/* Reject Button */}
        {canChangeStatus && (
          <button
            onClick={() => {
              setModalType("reject");
              toggle("approveReject");
            }}
            className={`${btnClass} btn-outline-danger d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2`}
            type="button"
            title="Reject Salary Ticket"
          >
            <CrossIcon width="12" height="12" />
            <span>Reject</span>
          </button>
        )}

        {/* Approve Button */}
        {canChangeStatus && (
          <button
            onClick={() => {
              setModalType("approve");
              toggle("approveReject");
            }}
            className={`${btnClass} btn-success d-inline-flex align-items-center gap-1.5 fw-semibold px-3.5 py-2 text-white shadow-sm`}
            style={{ background: "#059669", borderColor: "#059669" }}
            type="button"
            title="Approve Salary Ticket"
          >
            <CheckIcon />
            <span>Approve</span>
          </button>
        )}

        {/* Create Payment Advisory Button */}
        {canCreateVoucher && (
          <button
            onClick={() => {
              if (state?.salaryTicketData?.canInsertTDS) {
                toggleAlertModal();
              } else {
                toggle("voucher");
              }
            }}
            className={`${btnClass} btn-primary d-inline-flex align-items-center gap-2 fw-semibold px-4 py-2 shadow-sm text-white`}
            style={{ background: "#4f46e5", borderColor: "#4f46e5" }}
            type="button"
            title="Create Payment Advisory"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="5" width="20" height="14" rx="2" />
              <line x1="2" y1="10" x2="22" y2="10" />
            </svg>
            <span>Create Payment Advisory</span>
          </button>
        )}
      </div>
    );
  };

  return (
    <>
      {dataLoading && <BgBlurLoader />}
      {pageStates?.downloadLoading && <BgBlurLoader />}

      <div className="content container-fluid pb-5">
        {/* Main Header with Top Action Cluster */}
        <MainHeading showBackButton={true} title={"Salary Ticket Details"}>
          <div className="d-flex align-items-center gap-2">
            <button
              onClick={() => handleExportBankData(state?.salaryTicketData)}
              className="btn btn-outline-primary d-inline-flex align-items-center gap-2 fw-semibold px-3.5 py-2 shadow-sm"
              disabled={pageStates?.downloadLoading}
            >
              {pageStates?.downloadLoading ? (
                <>
                  <Spinner size="sm" />
                  <span>Download Bank Data</span>
                </>
              ) : (
                <>
                  <BankIcon />
                  <span>Download Bank Data</span>
                </>
              )}
            </button>
          </div>
        </MainHeading>

        {/* Rejected Alert Notice Banner */}
        {state?.salaryTicketData?.rejectReason && (
          <div
            className="alert border-0 rounded-3 p-3 mb-4 d-flex align-items-start gap-3 shadow-sm"
            style={{
              background: "#fef2f2",
              borderLeft: "4px solid #ef4444",
            }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                background: "#fee2e2",
                color: "#dc2626",
                width: "36px",
                height: "36px",
                fontSize: "14px",
              }}
            >
              ✕
            </div>
            <div className="flex-grow-1">
              <div
                className="fw-bold text-dark mb-1"
                style={{ fontSize: "14px" }}
              >
                Salary Ticket Rejected
              </div>
              <div style={{ color: "#991b1b", fontSize: "13px" }}>
                <strong>Reason: </strong>
                {state?.salaryTicketData?.rejectReason}
              </div>
            </div>
            <span
              className="badge rounded-pill px-3 py-1 flex-shrink-0"
              style={{
                background: "#fecdd3",
                color: "#9f1239",
                fontWeight: 600,
              }}
            >
              {state?.salaryTicketData?.status}
            </span>
          </div>
        )}

        {/* Master Summary Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            {/* Top Identity Strip */}
            <div
              className="d-flex align-items-start justify-content-between flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 p-2.5 flex-shrink-0"
                  style={{
                    background: "#f1f5f9",
                    color: "#334155",
                    width: "48px",
                    height: "48px",
                    fontSize: "20px",
                  }}
                >
                  💵
                </div>
                <div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <h3
                      className="mb-0 fw-bold text-dark"
                      style={{ letterSpacing: "-0.02em", fontSize: "1.35rem" }}
                    >
                      {state?.salaryTicketData?.ticketNumber || "--"}
                    </h3>
                    <span
                      className="badge rounded-pill px-2.5 py-1 fw-semibold d-inline-flex align-items-center gap-1"
                      style={{
                        fontSize: "12px",
                        background:
                          state?.salaryTicketData?.site?.type === "office"
                            ? "#f0fdf4"
                            : "#eff6ff",
                        color:
                          state?.salaryTicketData?.site?.type === "office"
                            ? "#166534"
                            : "#1d4ed8",
                        border: `1px solid ${
                          state?.salaryTicketData?.site?.type === "office"
                            ? "#bbf7d0"
                            : "#bfdbfe"
                        }`,
                      }}
                    >
                      <span>
                        {state?.salaryTicketData?.site?.type === "office"
                          ? "🏢"
                          : "📍"}
                      </span>
                      <span>
                        {state?.salaryTicketData?.site?.type === "office"
                          ? "Office Salary"
                          : state?.salaryTicketData?.site?.type === "site"
                          ? "Site Salary"
                          : "--"}
                      </span>
                    </span>
                    <div>
                      {HandlePurchaseRequestStatus(
                        state?.salaryTicketData?.status
                      )}
                    </div>
                  </div>
                  <div className="text-secondary small mt-1 d-flex align-items-center gap-2 flex-wrap">
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>
                        {state?.salaryTicketData?.site?.type === "office"
                          ? "🏢"
                          : "📍"}
                      </span>
                      <span>
                        <strong>
                          {state?.salaryTicketData?.site?.type === "office"
                            ? "Office:"
                            : "Site:"}
                        </strong>{" "}
                        {state?.salaryTicketData?.site?.name || "--"}
                      </span>
                    </span>
                    <span>•</span>
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>🗓️</span>
                      <span>
                        <strong>Month:</strong>{" "}
                        {state?.salaryTicketData?.month || "--"}
                      </span>
                    </span>
                    <span>•</span>
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📅</span>
                      <span>
                        <strong>Created:</strong>{" "}
                        {state?.salaryTicketData?.createdAt
                          ? moment(state?.salaryTicketData?.createdAt).format(
                              "DD-MM-YYYY"
                            )
                          : "--"}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              {/* Quick Quantitative Stats */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "110px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Total Amount
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {formatAmount(state?.salaryTicketData?.totalAmount) || "--"}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "110px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Remaining Amount
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {formatAmount(state?.salaryTicketData?.remainingAmount) ||
                      "--"}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "90px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Employees
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {totalEmployeesCount}
                  </div>
                </div>
              </div>
            </div>

            {/* Key Information Grid */}
            <div className="row g-3 pt-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    {state?.salaryTicketData?.site?.type === "office"
                      ? "Office Name"
                      : "Site Name"}
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={state?.salaryTicketData?.site?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {state?.salaryTicketData?.site?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    {state?.salaryTicketData?.site?.type === "office"
                      ? "Corporate Office"
                      : "Project / O&M Site"}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Salary Month
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {state?.salaryTicketData?.month || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Payout Period
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Created Date
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {state?.salaryTicketData?.createdAt
                      ? moment(state?.salaryTicketData?.createdAt).format(
                          "DD-MM-YYYY"
                        )
                      : "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Ticket Timestamp
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Created By
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={state?.salaryTicketData?.user?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {state?.salaryTicketData?.user?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5 text-truncate"
                    style={{ fontSize: "11px" }}
                  >
                    {state?.salaryTicketData?.user?.designation?.name ||
                      "Ticket Author"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* User's Salary Details Table Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div
            className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
            style={{ borderColor: "#f1f5f9" }}
          >
            <div className="d-flex align-items-center gap-2">
              <div
                className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                style={{ background: "#f1f5f9", color: "#475569" }}
              >
                <span
                  style={{
                    fontSize: "15px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 1,
                  }}
                >
                  👥
                </span>
              </div>
              <div>
                <h5
                  className="mb-0 fw-bold text-dark"
                  style={{ fontSize: "15px" }}
                >
                  Employee Salary Details
                </h5>
              </div>
            </div>
            <span
              className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
              style={{ fontSize: "12px", fontWeight: 600 }}
            >
              {totalEmployeesCount}{" "}
              {totalEmployeesCount === 1 ? "Employee" : "Employees"}
            </span>
          </div>

          <div className="table-responsive">
            <table
              className="table pr-detail-table align-middle mb-0"
              style={{ borderCollapse: "separate", borderSpacing: "0" }}
            >
              <thead style={{ background: "#f8fafc" }}>
                <tr>
                  <th
                    style={{
                      width: "60px",
                      padding: "12px 20px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    #
                  </th>
                  <th
                    style={{
                      width: "180px",
                      padding: "12px 20px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Employee Code
                  </th>
                  <th
                    style={{
                      minWidth: "240px",
                      padding: "12px 20px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Employee Name
                  </th>
                  <th
                    className="text-end"
                    style={{
                      width: "180px",
                      padding: "12px 20px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Net Pay
                  </th>
                </tr>
              </thead>
              <tbody>
                {state?.salaryTicketData?.salaryticketitems &&
                state.salaryTicketData.salaryticketitems.length > 0 ? (
                  state.salaryTicketData.salaryticketitems.map((item, i) => (
                    <tr
                      key={i}
                      style={{ borderBottom: "1px solid #f1f5f9" }}
                    >
                      <td
                        style={{
                          padding: "14px 20px",
                          fontSize: "13px",
                          color: "#94a3b8",
                          fontWeight: 600,
                        }}
                      >
                        {i + 1}
                      </td>
                      <td
                        style={{
                          padding: "14px 20px",
                          fontSize: "13px",
                          color: "#475569",
                        }}
                      >
                        <span
                          className="badge rounded-pill bg-light text-secondary border px-2.5 py-1 font-monospace"
                          style={{ fontSize: "12px" }}
                        >
                          {item?.usersalary?.user?.employeeCode || "--"}
                        </span>
                      </td>
                      <td style={{ padding: "14px 20px" }}>
                        <div
                          className="fw-semibold text-dark"
                          style={{ fontSize: "13.5px" }}
                        >
                          {item?.usersalary?.user?.name || "--"}
                        </div>
                      </td>
                      <td
                        className="text-end"
                        style={{
                          padding: "14px 20px",
                          fontSize: "13.5px",
                          color: "#0f172a",
                          fontWeight: 700,
                        }}
                      >
                        {formatAmount(item?.amount)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={4}
                      className="text-center py-4 text-muted small fw-bold"
                    >
                      No Employee Salary Details Found
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot
                style={{
                  background: "#f8fafc",
                  borderTop: "2px solid #e2e8f0",
                }}
              >
                <tr className="fw-bold">
                  <td
                    style={{
                      padding: "14px 20px",
                      fontSize: "13px",
                      color: "#0f172a",
                    }}
                  >
                    Total
                  </td>
                  <td></td>
                  <td></td>
                  <td
                    className="text-end"
                    style={{
                      padding: "14px 20px",
                      fontSize: "14px",
                      color: "#0f172a",
                      fontWeight: 700,
                    }}
                  >
                    {formatAmount(state?.salaryTicketData?.totalAmount)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        {/* Financial Summary Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            <div
              className="d-flex justify-content-between align-items-center flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "18px" }}>💰</span>
                <h5
                  className="mb-0 fw-bold text-dark"
                  style={{ fontSize: "15px" }}
                >
                  Financial Summary
                </h5>
              </div>
              <div>
                <span className="text-secondary small fw-medium">
                  All amounts in INR (₹)
                </span>
              </div>
            </div>

            <div className="row justify-content-end pt-3">
              <div className="col-12 col-md-7 col-lg-5">
                <div className="d-flex flex-column gap-2.5">
                  <div
                    className="d-flex align-items-center justify-content-between p-3 rounded-2"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <span
                      className="text-secondary fw-semibold"
                      style={{ fontSize: "14px" }}
                    >
                      Remaining Payable Amount:
                    </span>
                    <span
                      className="fw-bold text-dark"
                      style={{ fontSize: "15px" }}
                    >
                      {formatAmount(state?.salaryTicketData?.remainingAmount)}
                    </span>
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-between p-3 rounded-2 mt-1"
                    style={{
                      background: "#f0fdf4",
                      border: "1px solid #bbf7d0",
                    }}
                  >
                    <div>
                      <div
                        className="text-uppercase"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          color: "#166534",
                          letterSpacing: "0.04em",
                        }}
                      >
                        Total Payroll Amount
                      </div>
                      <div
                        className="text-muted"
                        style={{ fontSize: "11.5px" }}
                      >
                        Net disbursement amount
                      </div>
                    </div>
                    <div className="text-end">
                      <span
                        className="fw-bold"
                        style={{ fontSize: "1.35rem", color: "#15803d" }}
                      >
                        {formatAmount(state?.salaryTicketData?.totalAmount)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Description Card (if present) */}
        {state?.salaryTicketData?.description && (
          <div
            className="card border-0 shadow-sm rounded-3 mb-4"
            style={{ background: "#ffffff" }}
          >
            <div
              className="card-header bg-white py-3 px-4 d-flex align-items-center gap-2 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <span
                style={{
                  fontSize: "16px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: 1,
                  transform: "translateY(-2px)",
                }}
              >
                📝
              </span>
              <h5
                className="mb-0 fw-bold"
                style={{ fontSize: "14.5px", color: "#0f172a" }}
              >
                Description
              </h5>
            </div>
            <div className="card-body p-4">
              <div
                className="p-3 rounded-2"
                style={{
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  minHeight: "80px",
                  fontSize: "13.5px",
                  color: "#334155",
                  whiteSpace: "pre-wrap",
                }}
              >
                {state.salaryTicketData.description}
              </div>
            </div>
          </div>
        )}

        {/* Payment Advisories Section */}
        {(state?.salaryTicketData?.status?.includes("Approved") ||
          state?.salaryTicketData?.status?.includes("Completed") ||
          state?.salaryTicketData?.status?.includes("Finance Created")) && (
          <div
            className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
            style={{ background: "#ffffff" }}
          >
            <div
              className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-2">
                <div
                  className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                  style={{ background: "#f1f5f9", color: "#475569" }}
                >
                  <span style={{ fontSize: "15px" }}>💳</span>
                </div>
                <div>
                  <h5
                    className="mb-0 fw-bold text-dark"
                    style={{ fontSize: "15px" }}
                  >
                    Payment Advisories
                  </h5>
                </div>
              </div>
              <span
                className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
                style={{ fontSize: "12px", fontWeight: 600 }}
              >
                {pageStates?.count || 0} Advisories
              </span>
            </div>
            <div className="card-body p-3">
              <CommonTable
                TableHeading={TableHeading}
                TableData={pageStates?.VoucherList}
                ActionData={ActionData}
                currentPage={pageStates?.currentPage}
                PageChangeHandler={PageChangeHandler}
                isLoading={pageStates?.tableLoader}
                totalPages={pageStates?.totalPages}
                count={pageStates?.count}
                handleChangePageSize={handleChangePageSize}
                pageSize={pageStates?.pageSize}
              />
            </div>
          </div>
        )}

        {/* Bottom Action Bar */}
        {hasAnyAction && (
          <div
            className="card border-0 shadow-sm rounded-3 mb-4 p-3 d-flex flex-row align-items-center justify-content-between flex-wrap gap-3"
            style={{
              background: "#ffffff",
              borderLeft: "4px solid #4f46e5",
            }}
          >
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span
                className="text-secondary small fw-bold text-uppercase"
                style={{ letterSpacing: "0.04em" }}
              >
                Current Status:
              </span>
              <div>
                {HandlePurchaseRequestStatus(state?.salaryTicketData?.status)}
              </div>
            </div>
            <div>{renderActionButtons("md")}</div>
          </div>
        )}

        {/* Audit Trail & Activity Logs */}
        <Logs
          type={"salaryTicket"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
      </div>

      {/* Modals */}
      <ApproveRejectModal
        modal={modal.approveRejectModal}
        toggle={() => toggle("approveReject")}
        submitHandler={(reason) =>
          handleReqStatus(
            modalType === "reject" ? "Rejected" : "Approved",
            reason
          )
        }
        isLoading={isLoading}
        actionType={modalType}
      />
      <CreateVoucherModal
        isOpen={modal.createVoucherModel}
        toggle={() => toggle("voucher")}
        EditData={null}
        paymentTicketDetails={state?.salaryTicketData}
        GetPaymentTicketDetail={GetSalaryTicketDetail}
        GetVoucherList={GetVoucherList}
        from="salaryTicket"
      />
      <AlertModal
        modal={alertModal}
        toggle={toggleAlertModal}
        submitHandler={() => toggle("voucher")}
      />
    </>
  );
}
